export default __webpack_public_path__ + "static/media/car-wallet.5cbb650c.svg";